package com.checkin.host.util

fun openPdfInNewTab(bytes: ByteArray) {
    js(
        """
        (function(pdfBytes) {
            var blob = new Blob([pdfBytes], {type: 'application/pdf'});
            var url = URL.createObjectURL(blob);
            window.open(url, '_blank');
            setTimeout(function() { URL.revokeObjectURL(url); }, 120000);
        })
        """
    )(bytes)
}

fun downloadPdf(bytes: ByteArray, fileName: String) {
    js(
        """
        (function(pdfBytes, name) {
            var blob = new Blob([pdfBytes], {type: 'application/pdf'});
            var url = URL.createObjectURL(blob);
            var anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = name;
            anchor.rel = 'noopener noreferrer';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            setTimeout(function() { URL.revokeObjectURL(url); }, 120000);
        })
        """
    )(bytes, fileName)
}

fun downloadJsonFile(fileName: String, jsonText: String) {
    js(
        """
        (function(name, text) {
            var blob = new Blob([text], {type: 'application/json;charset=utf-8'});
            var url = URL.createObjectURL(blob);
            var anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = name;
            anchor.rel = 'noopener noreferrer';
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            setTimeout(function() { URL.revokeObjectURL(url); }, 120000);
        })
        """
    )(fileName, jsonText)
}
